import { matchPath } from "react-router-dom";

import type { Page } from "./types";

// Точное совпадение пути — для partners/landing/external у них путь конкретный.
export const indexPagesByPath = (pages: Page[]): Record<string, Page> => {
  const result: Record<string, Page> = {};

  for (const page of pages) {
    if (page.kind !== "native") {
      result[page.path] = page;
    }
  }

  return result;
};

// native хранит шаблон маршрута (как в AppRoutes.tsx), поэтому матчим через matchPath,
// а не точным совпадением — PageLayout используется и параметризованными маршрутами
// (/problems/:problemId и т.п.).
export const resolveNativeMenuOverride = (
  pathname: string,
  pages: Page[],
): string | undefined => {
  const match = pages
    .filter((page) => page.kind === "native")
    .find((page) => matchPath({ path: page.path, end: true }, pathname));

  return match?.menuSlug ?? undefined;
};
